<template>
  <div class="apply_drop_down_wrap">
    <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link" style="color: #1890ff;">
                   申请
                   <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="delivery">申请交收</el-dropdown-item>
        <el-dropdown-item command="contango">申请支付升贴水</el-dropdown-item>
        <el-dropdown-item command="unfreeze">申请解冻挂牌商品履约金</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <contango-pay-apply
      v-if="showContangoApply"
      :rowData="rowData"
      @done="showContangoApply = false" />
    <thaw-amount-apply
      v-if="showThawAmountApply"
      :rowData="rowData"
      @done="showThawAmountApply = false" />
  </div>
</template>

<script>
import ContangoPayApply from './ContangoPayApply.vue'
import ThawAmountApply from './ThawAmountApply.vue'
export default {
  name: 'ApplyDropdown',
  components: {
    ContangoPayApply,
    ThawAmountApply
  },
  props: {
    rowData: { // 行数据
      default: () => {},
      isRequired: true
    }
  },
  data () {
    return {
      showContangoApply: false, // 显示升贴水支付申请的弹窗
      showThawAmountApply: false // 显示解冻金额申请的弹窗
    }
  },
  methods: {
    // 卖方申请下拉菜单的各项操作
    handleCommand (command) {
      switch (command) {
        case 'delivery': { // 卖方交收单申请
          this.$router.push({ path: `/framework/myTrading/myOrder/sellerDelivery/${this.rowData.id}/S` })
          break
        }
        case 'contango': { // 显示升贴水支付申请的弹窗
          this.showContangoApply = true
          break
        }
        case 'unfreeze': { // 显示解冻金额申请的弹窗
          this.showThawAmountApply = true
          break
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
